import { Controller } from '@hotwired/stimulus'
import { trans, SELECT_NOTIFICATION_GROUPS } from '../../translator'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'

const notificationDropdownConfig = {
  placeholder: trans(SELECT_NOTIFICATION_GROUPS, {}, 'logs'),
  fullTextSearch: true,
  match: 'text',
  onAdd: function (addedValue, addedText, addedChoice) {
    if (addedValue === 'ALL') {
      $(this).parent().find('a').each(function () {
        if ($(this).attr('data-value') !== 'ALL') {
          $(this).find('i').click()
        }
      })

      $(this).parent().find('.item').each(function (e) {
        $(this).addClass('disabled')
      })
    }
  },
  onRemove: function (removedValue, removedText, removedChoice) {
    if (removedValue === 'ALL') {
      $(this).parent().find('.item.disabled').each(function (e) {
        $(this).removeClass('disabled')
      })
    }
  }
}

export default class extends Controller {
  static targets = [
    'header', 'checklists', 'checklistName', 'checklistTaskCount', 'checklistTemplate'
  ]

  connect () {
    document.querySelectorAll('.checklist .notification-groups').forEach((checklistNotificationDropdown) => {
      $(checklistNotificationDropdown).dropdown(notificationDropdownConfig)
    })
  }

  setupModal () {
    this.checklistTaskCountTargets.forEach((target) => {
      let highestLabel = 0
      document.querySelectorAll(`.checklist[data-checklist-type-id="${target.dataset.checklistTypeId}"]`).forEach((checklist) => {
        if (parseInt(checklist.dataset.label) > highestLabel) {
          highestLabel = parseInt(checklist.dataset.label)
        }
      })
      target.dataset.currentLabel = highestLabel + 1
    })

    this.checklistTaskCountTargets.forEach((target) => {
      const checklistTypeCount = document.querySelectorAll(`.checklist[data-checklist-type-id="${target.dataset.checklistTypeId}"]`).length
      target.value = checklistTypeCount
      target.dataset.originalCount = checklistTypeCount
    })
  }

  incrementAllChecklists () {
    this.checklistTaskCountTargets.forEach((target) => {
      target.value = Math.max(1, parseInt(target.value))
    })
  }

  addChecklists () {
    this.checklistTaskCountTargets.forEach((target) => {
      for (let i = parseInt(target.dataset.originalCount); i < parseInt(target.value); i++) {
        this.headerTarget.classList.remove('d-none')

        const newChecklist = this.checklistTemplateTarget.cloneNode(true)
        delete newChecklist.dataset.logChecklistsTarget
        newChecklist.classList.add('checklist')
        newChecklist.dataset.checklistTypeId = target.dataset.checklistTypeId
        newChecklist.dataset.label = target.dataset.currentLabel
        newChecklist.classList.remove('d-none')

        newChecklist.querySelector('.checklist-type-name').value = target.dataset.checklistTypeName
        newChecklist.querySelector('.checklist-name').value = target.dataset.checklistTypeName + (target.dataset.currentLabel > 1 ? ` ${target.dataset.currentLabel}` : '')
        target.dataset.currentLabel = parseInt(target.dataset.currentLabel) + 1
        $(newChecklist.querySelector('.notification-groups')).dropdown(notificationDropdownConfig)

        this.checklistsTarget.appendChild(newChecklist)
      }

      target.dataset.originalCount = target.value
    })
  }

  removeChecklist (event) {
    event.currentTarget.closest('.checklist').remove()
    if (document.querySelectorAll('.checklist').length === 0) {
      this.headerTarget.classList.add('d-none')
    }
  }
}
